<!--
 * @Description: tabs
 * @Author: luocheng
 * @Date: 2021-10-08 17:11:12
 * @LastEditors: 冉桂精 156189868@qq.com
 * @LastEditTime: 2025-01-24 09:04:02
-->
<template>
  <div v-loading="loading">
    <div v-if="gisComponentId && baseInfo.heights?.length"  class="water-play-cont">
      <el-slider height="8" v-model="progress"></el-slider>
      <div v-if="heightVal" class="desc">当前高度： <span>{{heightVal}}</span></div> 
      <div class="play-btn">
        <i class="iconfont" @click="onHandle" :class="isPlay?'iconkaishi':'iconzanting'"></i>
      </div>
    </div>
    <div class="water-play-empty" v-else >暂无数据</div>
  </div>
</template>

<script>
import { dataInterface } from '@/apis/data/index';
import { initParams } from '@/utils/tools';
import eventBus from '@/plugins/eventBus';
import { removeEventBus } from '@/utils/tools';
import { mapState } from 'vuex';
import { Slider } from 'element-ui';
let submergence = null;

export default {
  name: 'CommonWaterPaly',
  components:{
    "el-slider" : Slider,
  },
  props: {
    element: {
      type: Object,
      required: false,
      default: () => {}
    },
    componentList: {
      default: null
    },
    // 是否为分组
    isGroup: {
      type: Boolean,
    },
    // 当前分组的组件数据
    groupComponents: {
      type: Array,
      default: () => []
    },
    scaleHeight: {
			type: Number,
			default: 1
		},
		scaleWidth: {
			type: Number,
			default: 1
		},
  },
  inject: ['EDITOR_pageUUID'],
  data() {
    return {
      requestParam:null,
      loading:false,
      progress:0,
      isPlay:false,
      playStatus:'',
      data:[],
      heightVal:0,
      baseInfo :{
        kml: '',  //水库范围kml的地址
        heights: [],  //也可以为[908, 1005]，淹没过程中的水位值
        fillColor: '#006ab4',  //水面颜色
        fillAlpha: 80,
        submergenceType: 'time',  //还可以选择speed，用于选择是总时间播放还是按照指定速度播放
        time: 20,  //单位为秒
        speed: 2, //单位为m/s
        isOutRange: false,   //是否超出kml范围
        isLocation: true,
        isLabel: true  //是否有水位标签
      }
    };
  },
  computed: {
    ...mapState(['componentData', 'subsidiaryComponentData']),
    baseConfig(){
      return this.element.baseConfig;
    },
    // 嵌入页面的参数获取
    subComponentData() {
      if (this.EDITOR_pageUUID) {
				return this.subsidiaryComponentData?.[this.EDITOR_pageUUID]?.componentData || this.componentList || this.componentData || [];
			}
			return this.componentList || this.componentData || [];
    },
    database() {
			return this.element && this.element.database;
		},
    gisComponentId(){
      let info = this.findComponentWithField(this.subComponentData,'ViewerGIS');
      if(info){
        return info.id;
      }
      return ''
    }
  },
  mounted() {
    // 监听请求
		// 配置关联参数的容器才需要监听
		const databaseTrigger = {
			[this.element.id]: () => {
        const {
          search = [],
          param = {},
          canPost
        } = initParams(
          this.element?.database?.paramsConfig || [],
          this.isGroup,
          this.subComponentData,
          this.groupComponents,
          this.element
        );
        if (!canPost) {
          this._failDataDebug('参数必填校验未通过');
          return;
        }
        // console.log(param,this.element.id,this.requestParam);
        if(this.requestParam){
          if(Object.keys(this.requestParam).length !== Object.keys(param).length){
            return
          }
        }
        this.requestParam = param;
        if(param.kml?.length){
          this.baseInfo.kml = param.kml[0].path;
        }
        
        this.getList(this.element.database, search, param);
			}
		};
		eventBus.$on('databaseTrigger', databaseTrigger[this.element.id]);
   
  },  
  methods: {
    onHandle(){
      if(!submergence){
        return;
      }
      if(!this.playStatus){
        submergence.play();
        this.playStatus='playing';
      } else if(this.playStatus === 'playing'){
        submergence.pause();
        this.playStatus='pauseing';
      } else if(this.playStatus==='pauseing'){
        submergence.continue();
        this.playStatus='playing';
      }
      this.isPlay = !this.isPlay;
    },
    initWaterInfo(){
      if(this.gisComponentId && this.baseInfo.kml){
        eventBus.$emit("ViewerGIS.createSubmergenceReal",this.gisComponentId, new Date(), {
          options: this.baseInfo,
          progressCallback: (progress,height) => {
            this.progress = progress;
            this.heightVal = Number(height).toFixed(2);
            if(+progress === 100){
              submergence.reset();
              this.playStatus = '';
              this.heightVal = 0;
              this.isPlay = false;
              this.progress = 0;
            }
          },
        }, (res) => {
          submergence = res;
        });
      }
    },
    resetData(){
      this.playStatus = '';
      this.heightVal = 0;
      this.isPlay = false;
      this.progress = 0;
      if(submergence){
        submergence.reset();
        submergence = null;
      }
    },
    /**
	 * @desc: 根据字段查找组件
	 */
    findComponentWithField(componentList, field, type = 'component'){
      for (let i = 0, len = componentList.length; i < len; i++) {
        const item = componentList[i];
        if (item[type] === field) {
          return item;
        }
        if (item.children && Array.isArray(item.children) && item.children.length) {
          const result = this.findComponentWithField(item.children, field, type) || null;
          if (result) {
            return result;
          }
        }
      }
      return null;
    },
    /**
		 * @desc: 获取渲染列表
		 * @param {Object} database 数据配置对象
		 * @param {Array} search 搜索
		 */
		getList(database, search = [], params = {}) {
      this.resetData();
			// 外部参数
			// 注入的参数
			let outParams = {};
			if (this.element.database.userOutParams) {
				outParams = sessionStorage.getItem(
					`dialogRelationParams_${this.EDITOR_pageUUID || this.$route.query.pageUUID}`
				);
				outParams = outParams ? JSON.parse(outParams) : {};
			}
			this.loading = true;
			const paramsObj = {
				...params,
				...outParams,
				search
			};
			// 配置
			let __method_name__ = 'dataList';
			const mapping = database.mapping;
			let configObj = null;
			let url = '/api/mapi';
			if (mapping === 'interface') {
				configObj = {
					...paramsObj,
				}
				if (database?.interfaceConfig?.url?.indexOf('http') === -1) {
					url = `/api${database?.interfaceConfig?.url}`;
				} else {
					url = database?.interfaceConfig?.url
				}
			} else if (mapping === 'object') {
				configObj = {
					__method_name__,
					object_uuid: database.objectData.uuid,
					view_uuid: database.viewData.uuid,
					...paramsObj
				};
			} else if (mapping === 'relation') {
				__method_name__ = 'relationList';
				configObj = {
					__method_name__: 'relationList',
					object_uuid: database.objectData.uuid,
					relationship_uuid: database.relationData.uuid,
					...paramsObj
				};
			}
			dataInterface(configObj, url).then((res) => {
				if (res?.data?.data?.length) {
          let data = res.data.data[0];
          if(data.monitor_hour){
              this.baseInfo.heights.length = 0;
              if(res.data.data.length > 1){
                for(let i=0;i<res.data.data.length;i++){
                  this.baseInfo.heights.push(res.data.data[i].avg)
                }
                this.initWaterInfo();
              }
          } else {
            const kml_range = typeof data.kml_range === 'string'?JSON.parse(data.kml_range):data.kml_range;
            if(!kml_range.length || !kml_range[0].path || !configObj.type) return
            this.baseInfo.kml = kml_range[0].path;
            switch (+configObj.type){
              case 1:
                //放空模拟
                this.baseInfo.heights = [Number(data.normal_storage_level), Number(data.storage_water_min)];
                break;
              case 2:
                //放满模拟
                this.baseInfo.heights = [Number(data.normal_storage_level), Number(data.design_flood_level)];
                break;
              case 3:
                //蓄水模拟
                this.baseInfo.heights = [Number(data.storage_water_min), Number(data.normal_storage_level)];
                break;
              case 4:
                //洪水模拟
                this.baseInfo.heights = [Number(data.storage_water_min), Number(data.design_flood_level)];
                break;
              case 5:
                this.baseInfo.heights = [Number(data.initial_water), Number(data.forecast_water)];
                break;
            }
            this.initWaterInfo();
          }
        }
        this.loading = false;
			}).catch((err) => {
				console.log(err);
				this.loading = false;
			});
		},
  },
  destroyed() {
    if(submergence){
      eventBus.$emit("ViewerGIS.removeAllAnalysis",this.gisComponentId);
    }
    removeEventBus('databaseTrigger', this.element.id);
  }
};
</script>

<style lang="less" scoped>
  .water-play-cont{
    min-width: 400px;
    width: 100%;
    height: 100%;
    padding:0px 70px 10px 20px;
    box-sizing: border-box;
    position:relative;
    overflow: hidden;
    z-index: 10;
    text-align: left;
    :deep(.el-slider__button){
      height: 10px;
      width: 10px;
      border-color:#fff;
    }
    :deep(.el-slider__bar){
      background-color: #1897A0;
    }
    .desc{
      font-family: "PingFang SC";
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%; /* 18px */
      letter-spacing: 0.4px;
      color: #8FC7FF;
      span{
        color: #fff;
        font-family: YouSheBiaoTiHei;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 18px */
        letter-spacing: 0.4px;
      }
    }
    .play-btn{
      width: 38px;
      height: 38px;
      line-height: 38px;
      position: absolute;
      top: 16px;
      right: 10px;
      border-radius: 50%;
      fill: linear-gradient(0deg, rgba(24,151,160, 0.80) -0.01%, rgba(5, 28, 68, 0.00) 111.12%);
      box-shadow: 0px 0px 20px 0px #1897A0 inset;
      text-align: center;
      i{
        font-size: 25px;
        color:#fff;
      }
      .iconzanting{
        margin-left: 3px;
      }
    }
  }
  .water-play-empty{
    color:#fff;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
